/**
 * Avora Track Your Order — Form submission, API call, render states, animations
 */
(function () {
  'use strict';

  /* ── Country lookup ── */
  var COUNTRIES = {
    CN: { flag: '\u{1F1E8}\u{1F1F3}', name: 'China' },
    FR: { flag: '\u{1F1EB}\u{1F1F7}', name: 'France' },
    DE: { flag: '\u{1F1E9}\u{1F1EA}', name: 'Germany' },
    US: { flag: '\u{1F1FA}\u{1F1F8}', name: 'United States' },
    GB: { flag: '\u{1F1EC}\u{1F1E7}', name: 'United Kingdom' },
    ES: { flag: '\u{1F1EA}\u{1F1F8}', name: 'Spain' },
    IT: { flag: '\u{1F1EE}\u{1F1F9}', name: 'Italy' },
    NL: { flag: '\u{1F1F3}\u{1F1F1}', name: 'Netherlands' },
    BE: { flag: '\u{1F1E7}\u{1F1EA}', name: 'Belgium' },
    PT: { flag: '\u{1F1F5}\u{1F1F9}', name: 'Portugal' },
    AT: { flag: '\u{1F1E6}\u{1F1F9}', name: 'Austria' },
    SE: { flag: '\u{1F1F8}\u{1F1EA}', name: 'Sweden' },
    PL: { flag: '\u{1F1F5}\u{1F1F1}', name: 'Poland' },
    HK: { flag: '\u{1F1ED}\u{1F1F0}', name: 'Hong Kong' },
    SG: { flag: '\u{1F1F8}\u{1F1EC}', name: 'Singapore' },
    JP: { flag: '\u{1F1EF}\u{1F1F5}', name: 'Japan' },
    KR: { flag: '\u{1F1F0}\u{1F1F7}', name: 'South Korea' },
    AU: { flag: '\u{1F1E6}\u{1F1FA}', name: 'Australia' },
    CA: { flag: '\u{1F1E8}\u{1F1E6}', name: 'Canada' },
    CH: { flag: '\u{1F1E8}\u{1F1ED}', name: 'Switzerland' },
    DK: { flag: '\u{1F1E9}\u{1F1F0}', name: 'Denmark' },
    NO: { flag: '\u{1F1F3}\u{1F1F4}', name: 'Norway' },
    FI: { flag: '\u{1F1EB}\u{1F1EE}', name: 'Finland' },
    IE: { flag: '\u{1F1EE}\u{1F1EA}', name: 'Ireland' },
    GR: { flag: '\u{1F1EC}\u{1F1F7}', name: 'Greece' },
    CZ: { flag: '\u{1F1E8}\u{1F1FF}', name: 'Czech Republic' },
    RO: { flag: '\u{1F1F7}\u{1F1F4}', name: 'Romania' },
    HU: { flag: '\u{1F1ED}\u{1F1FA}', name: 'Hungary' }
  };

  /* ── Status config ── */
  var STATUS_COLORS = {
    0:  '#C4A882',
    10: '#C4A882',
    30: '#4A9E6B',
    40: '#4A9E6B',
    50: '#9C9590',
    60: '#C27854',
    20: '#9C9590',
    35: '#C27854'
  };

  var STATUS_TO_STEP = {
    0:  1,
    10: 3,
    30: 4,
    40: 5
  };

  var STEP_LABELS = ['Confirmed', 'Picked Up', 'In Transit', 'Out for Delivery', 'Delivered'];

  /* ── Chinese → English auto-translation ── */
  var CN_PHRASES = [
    [/中国邮政已收取邮件/g, 'China Post has collected the package'],
    [/中国邮政速递物流/g, 'China Post EMS'],
    [/邮件已在【([^】]*)】完成分拣，准备发出/g, 'Package sorted at [$1], ready to dispatch'],
    [/邮件离开【([^】]*)】，正在发往【([^】]*)】/g, 'Package left [$1], heading to [$2]'],
    [/邮件到达处理中心【([^】]*)】/g, 'Package arrived at processing center [$1]'],
    [/邮件离开处理中心【([^】]*)】/g, 'Package left processing center [$1]'],
    [/邮件到达【([^】]*)】/g, 'Package arrived at [$1]'],
    [/邮件离开【([^】]*)】/g, 'Package left [$1]'],
    [/已交航空公司运输/g, 'Handed to airline for transport'],
    [/到达目的国/g, 'Arrived in destination country'],
    [/离开目的国/g, 'Left destination country'],
    [/到达寄达地/g, 'Arrived at destination'],
    [/海关放行/g, 'Customs cleared'],
    [/送交海关/g, 'Submitted to customs'],
    [/海关扣留/g, 'Held by customs'],
    [/清关完成/g, 'Customs clearance completed'],
    [/清关中/g, 'Customs clearance in progress'],
    [/已清关/g, 'Customs cleared'],
    [/投递并签收/g, 'Delivered and signed for'],
    [/已签收/g, 'Signed for / Delivered'],
    [/正在投递/g, 'Out for delivery'],
    [/投递成功/g, 'Delivery successful'],
    [/到达(.+?)投递局/g, 'Arrived at $1 delivery office'],
    [/离开(.+?)发往(.+)/g, 'Left $1, heading to $2'],
    [/已离开(.+)/g, 'Has left $1'],
    [/已到达(.+)/g, 'Has arrived at $1'],
    [/揽收成功/g, 'Pickup successful'],
    [/已揽收/g, 'Picked up'],
    [/揽收/g, 'Picked up'],
    [/发往(.+)/g, 'Heading to $1'],
    [/派送中/g, 'Out for delivery'],
    [/运输中/g, 'In transit'],
    [/已发出/g, 'Dispatched'],
    [/正在处理/g, 'Being processed'],
    [/航空运输/g, 'Air transport'],
    [/陆运/g, 'Ground transport'],
    [/已出口/g, 'Exported'],
    [/已进口/g, 'Imported'],
    [/退回/g, 'Returned'],
    [/退件/g, 'Return shipment'],
    [/包裹/g, 'package'],
    [/快件/g, 'express item'],
    [/邮件/g, 'package'],
    [/处理中心/g, 'processing center'],
    [/营业部/g, 'office'],
    [/国际公司直属国际营业部/g, 'International Division'],
    [/国际/g, 'international'],
    [/到达/g, 'arrived at'],
    [/离开/g, 'left'],
    [/正在/g, 'currently'],
    [/准备/g, 'preparing to'],
    [/完成/g, 'completed'],
    [/分拣/g, 'sorting'],
    [/发出/g, 'dispatch']
  ];

  function hasChinese(str) {
    return /[一-鿿]/.test(str);
  }

  function translateChinese(str) {
    if (!str || !hasChinese(str)) return str;
    var result = str;
    for (var i = 0; i < CN_PHRASES.length; i++) {
      result = result.replace(CN_PHRASES[i][0], CN_PHRASES[i][1]);
    }
    return result;
  }

  /* ── DOM refs ── */
  var form = document.getElementById('avora-tracking-form');
  var input = document.getElementById('avora-tracking-input');
  var btn = document.getElementById('avora-tracking-btn');
  var resultsWrap = document.getElementById('avora-tracking-results');
  var resultsInner = document.getElementById('avora-tracking-results-inner');

  if (!form || !input || !btn || !resultsWrap || !resultsInner) return;

  var apiUrl = form.dataset.apiUrl;
  var lastTrackingNumber = '';

  /* ── Helpers ── */
  function getCountry(code) {
    if (!code) return { flag: '', name: '' };
    return COUNTRIES[code] || { flag: '', name: code };
  }

  function formatDate(isoStr) {
    if (!isoStr) return '';
    var d = new Date(isoStr);
    if (isNaN(d.getTime())) return isoStr;
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var h = d.getHours();
    var m = d.getMinutes();
    var ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    var mm = m < 10 ? '0' + m : m;
    return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear() + ' \u00B7 ' + h + ':' + mm + ' ' + ampm;
  }

  /* ── Render: Loading ── */
  function renderLoading() {
    return '<div class="avora-tracking__loading">' +
      '<div class="avora-tracking__spinner"></div>' +
      '<p class="avora-tracking__loading-text">Checking your shipment status\u2026</p>' +
    '</div>';
  }

  /* ── Render: Success ── */
  function renderSuccess(data) {
    var activeStep = STATUS_TO_STEP[data.status] !== undefined ? STATUS_TO_STEP[data.status] : 2;
    var statusColor = STATUS_COLORS[data.status] || '#9C9590';
    var origin = getCountry(data.originCountry);
    var dest = getCountry(data.destCountry);

    // Progress bar HTML
    var progressHtml = '<div class="avora-tracking__progress">';
    progressHtml += '<div class="avora-tracking__progress-line-track">';
    // Background line segments
    for (var i = 0; i < 4; i++) {
      progressHtml += '<div class="avora-tracking__progress-line-bg" style="left:' + (i * 25 + 10) + '%;width:' + (25 - (i === 3 ? 10 : 0) - (i === 0 ? 10 : 0)) + '%;"></div>';
    }
    progressHtml += '</div>';
    for (var s = 0; s < 5; s++) {
      var isActive = s < activeStep;
      var isCurrent = s === activeStep - 1;
      var dotCls = 'avora-tracking__progress-dot';
      if (isActive) dotCls += ' is-active';
      if (isCurrent) dotCls += ' is-current';
      var labelCls = 'avora-tracking__progress-label';
      if (isActive) labelCls += ' is-active';
      progressHtml += '<div class="avora-tracking__progress-step">' +
        '<div class="' + dotCls + '" data-step="' + s + '"></div>' +
        '<span class="' + labelCls + '">' + STEP_LABELS[s] + '</span>' +
      '</div>';
    }
    progressHtml += '</div>';

    // Route indicator
    var routeHtml = '';
    if (data.originCountry && data.destCountry) {
      routeHtml = '<div class="avora-tracking__route">' +
        '<span class="avora-tracking__route-point"><span class="avora-tracking__route-flag">' + origin.flag + '</span> ' + origin.name + '</span>' +
        '<div class="avora-tracking__route-line" id="avora-tracking-route-line"></div>' +
        '<span class="avora-tracking__route-arrow">\u25B6</span>' +
        '<span class="avora-tracking__route-point"><span class="avora-tracking__route-flag">' + dest.flag + '</span> ' + dest.name + '</span>' +
      '</div>';
    }

    // Timeline
    var timelineHtml = '<div class="avora-tracking__timeline">' +
      '<p class="avora-tracking__timeline-label">Shipment History</p>';
    var events = data.events || [];
    for (var e = 0; e < events.length; e++) {
      var ev = events[e];
      var evCountry = getCountry(ev.country);
      timelineHtml += '<div class="avora-tracking__event" data-delay="' + (e * 80) + '">' +
        '<div class="avora-tracking__event-dot-col">' +
          '<div class="avora-tracking__event-dot"></div>' +
          '<div class="avora-tracking__event-line"></div>' +
        '</div>' +
        '<div class="avora-tracking__event-content">' +
          '<p class="avora-tracking__event-date">' + formatDate(ev.date) + '</p>' +
          '<p class="avora-tracking__event-desc">' + escapeHtml(translateChinese(ev.description)) + '</p>' +
          (ev.country ? '<span class="avora-tracking__event-country"><span class="avora-tracking__event-country-flag">' + evCountry.flag + '</span> ' + evCountry.name + '</span>' : '') +
        '</div>' +
      '</div>';
    }
    timelineHtml += '</div>';

    // Share link button
    var shareHtml = '<div class="avora-tracking__share-wrap" id="avora-tracking-share">' +
      '<button class="avora-tracking__share-btn" id="avora-tracking-share-btn" data-tracking="' + escapeHtml(data.trackingNumber) + '">' +
        '<svg class="avora-tracking__share-icon" viewBox="0 0 16 16" fill="none"><path d="M6 9.5l4-3M10 3.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM3 8a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM10 12.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM6 9.5l4 3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '<span class="avora-tracking__share-text">Share Tracking Link</span>' +
        '<span class="avora-tracking__share-check">' +
          '<svg class="avora-tracking__share-check-icon" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="8" stroke="#C4A882" stroke-width="1.2"/><polyline points="5.5,9 8,11.5 12.5,6.5" stroke="#C4A882" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '<span class="avora-tracking__share-check-text">Copied!</span>' +
        '</span>' +
      '</button>' +
    '</div>';

    // Help card
    var helpHtml = '<div class="avora-tracking__help" id="avora-tracking-help">' +
      '<p class="avora-tracking__help-heading">Need help with your order?</p>' +
      '<p class="avora-tracking__help-text">If your tracking hasn\u2019t updated in more than 7 days or you\u2019re experiencing an issue, our team is here to help.</p>' +
      '<a href="/pages/contact" class="avora-tracking__help-btn">Contact Support</a>' +
    '</div>';

    // Assemble status card
    return '<div class="avora-tracking__status-card">' +
      '<div class="avora-tracking__status-top">' +
        '<div>' +
          '<span class="avora-tracking__badge" style="background:' + statusColor + '">' + escapeHtml(translateChinese(data.statusLabel || 'Unknown')) + '</span>' +
          '<p class="avora-tracking__tracking-num">' + escapeHtml(data.trackingNumber) + '</p>' +
          '<p class="avora-tracking__carrier">Carrier: ' + escapeHtml(translateChinese(data.carrier || 'Unknown')) + '</p>' +
        '</div>' +
      '</div>' +
      progressHtml +
      routeHtml +
      '<p class="avora-tracking__last-updated">Last updated: ' + formatDate(data.lastEventTime) + '</p>' +
    '</div>' +
    shareHtml +
    timelineHtml +
    helpHtml;
  }

  /* ── Render: Error / Not Found ── */
  function renderError() {
    return '<div class="avora-tracking__error">' +
      '<div class="avora-tracking__error-icon">\u2298</div>' +
      '<p class="avora-tracking__error-msg">We couldn\u2019t find tracking information for this number.</p>' +
      '<ul class="avora-tracking__error-reasons">' +
        '<li>The tracking number may be incorrect</li>' +
        '<li>Your order may not have shipped yet</li>' +
        '<li>Tracking data may take up to 48 hours to appear</li>' +
      '</ul>' +
      '<div class="avora-tracking__error-actions">' +
        '<button class="avora-tracking__error-retry" id="avora-tracking-retry">Try Again</button>' +
      '</div>' +
    '</div>';
  }

  /* ── HTML escape ── */
  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* ── Show results with animation ── */
  function showResults(html) {
    // Add shared link banner if arriving from a shared URL with successful results
    var bannerHtml = '';
    if (isSharedLink && html.indexOf('avora-tracking__status-card') !== -1) {
      bannerHtml = '<div class="avora-tracking__shared-banner">' +
        '<svg class="avora-tracking__shared-icon" viewBox="0 0 14 14" fill="none">' +
          '<path d="M6 5.5l2-1.5M8 3a1.25 1.25 0 1 0 2.5 0A1.25 1.25 0 0 0 8 3ZM3.5 7a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0ZM8 11a1.25 1.25 0 1 0 2.5 0A1.25 1.25 0 0 0 8 11ZM6 8.5l2 1.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        '<span class="avora-tracking__shared-text">Shared tracking link \u2014 <strong>live updates</strong></span>' +
      '</div>';
    }

    resultsInner.innerHTML = bannerHtml + html;
    resultsWrap.style.display = 'block';
    resultsInner.classList.remove('is-visible');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        resultsInner.classList.add('is-visible');
        animateElements();
      });
    });
  }

  /* ── Post-render animations ── */
  function animateElements() {
    // Progress dots stagger
    var dots = resultsInner.querySelectorAll('.avora-tracking__progress-dot');
    dots.forEach(function (dot, i) {
      setTimeout(function () {
        dot.classList.add('is-animated');
      }, 150 * i);
    });

    // Progress line fill
    var lineTrack = resultsInner.querySelector('.avora-tracking__progress-line-track');
    if (lineTrack) {
      var activeDots = resultsInner.querySelectorAll('.avora-tracking__progress-dot.is-active');
      if (activeDots.length > 0) {
        var lastActive = activeDots[activeDots.length - 1];
        var step = parseInt(lastActive.dataset.step, 10);
        // Create fill line from 10% to the active step position
        var fillPct = step * 25;
        var fill = lineTrack.querySelector('.avora-tracking__progress-line-fill');
        if (!fill) {
          fill = document.createElement('div');
          fill.className = 'avora-tracking__progress-line-fill';
          fill.style.left = '10%';
          lineTrack.appendChild(fill);
        }
        setTimeout(function () {
          fill.style.width = Math.min(fillPct, 80) + '%';
        }, 100);
      }
    }

    // Route line draw
    var routeLine = document.getElementById('avora-tracking-route-line');
    if (routeLine) {
      setTimeout(function () {
        routeLine.classList.add('is-animated');
      }, 300);
    }

    // Timeline events stagger
    var events = resultsInner.querySelectorAll('.avora-tracking__event');
    events.forEach(function (ev, i) {
      setTimeout(function () {
        ev.classList.add('is-visible');
      }, 400 + (80 * i));
    });

    // Help card fade in after timeline
    var help = document.getElementById('avora-tracking-help');
    if (help) {
      var helpDelay = 400 + (events.length * 80) + 200;
      setTimeout(function () {
        help.classList.add('is-visible');
      }, helpDelay);
    }

    // Share button handler
    var shareWrap = document.getElementById('avora-tracking-share');
    var shareBtn = document.getElementById('avora-tracking-share-btn');
    if (shareWrap) {
      var shareDelay = helpDelay + 200;
      setTimeout(function () {
        shareWrap.classList.add('is-visible');
      }, shareDelay > 0 ? shareDelay : 600);
    }
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var trackNum = shareBtn.dataset.tracking;
        var shareUrl = window.location.origin + '/pages/order-tracking?track=' + encodeURIComponent(trackNum);

        navigator.clipboard.writeText(shareUrl).then(function () {
          // Button success state
          shareBtn.classList.add('is-copied');

          // Show floating toast
          showToast(trackNum);

          // Reset button after delay
          setTimeout(function () {
            shareBtn.classList.remove('is-copied');
          }, 2800);
        }).catch(function () {
          // Fallback: select a temporary input
          var tmp = document.createElement('input');
          tmp.value = shareUrl;
          document.body.appendChild(tmp);
          tmp.select();
          document.execCommand('copy');
          document.body.removeChild(tmp);
          shareBtn.classList.add('is-copied');
          showToast(trackNum);
          setTimeout(function () {
            shareBtn.classList.remove('is-copied');
          }, 2800);
        });
      });
    }

    // Retry button handler
    var retryBtn = document.getElementById('avora-tracking-retry');
    if (retryBtn) {
      retryBtn.addEventListener('click', function () {
        input.focus();
        input.select();
        resultsWrap.style.display = 'none';
        resultsInner.innerHTML = '';
        resultsInner.classList.remove('is-visible');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  /* ── Toast notification ── */
  var toastEl = null;
  var toastTimer = null;

  function showToast(trackNum) {
    // Remove existing toast
    if (toastEl) {
      toastEl.parentNode.removeChild(toastEl);
      clearTimeout(toastTimer);
    }

    toastEl = document.createElement('div');
    toastEl.className = 'avora-tracking__toast';
    toastEl.innerHTML = '<div class="avora-tracking__toast-inner">' +
      '<svg class="avora-tracking__toast-icon" viewBox="0 0 20 20" fill="none">' +
        '<circle class="avora-tracking__toast-icon-ring" cx="10" cy="10" r="8" stroke-width="1.5"/>' +
        '<polyline class="avora-tracking__toast-icon-check" points="6,10 9,13 14,7"/>' +
      '</svg>' +
      '<span class="avora-tracking__toast-text"><strong>Link copied</strong> \u2014 ready to share</span>' +
      '<div class="avora-tracking__toast-progress"></div>' +
    '</div>';

    document.body.appendChild(toastEl);

    // Trigger entrance
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toastEl.classList.add('is-visible');
      });
    });

    // Auto-dismiss
    toastTimer = setTimeout(function () {
      if (toastEl) {
        toastEl.classList.remove('is-visible');
        setTimeout(function () {
          if (toastEl && toastEl.parentNode) {
            toastEl.parentNode.removeChild(toastEl);
            toastEl = null;
          }
        }, 400);
      }
    }, 3200);
  }

  /* ── Shared link detection ── */
  var isSharedLink = new URLSearchParams(window.location.search).has('track');

  if (isSharedLink) {
    resultsWrap.classList.add('is-shared-link');
  }

  /* ── API call ── */
  function doTrack(trackingNumber) {
    if (!trackingNumber.trim()) return;
    lastTrackingNumber = trackingNumber.trim();

    // Show loading
    btn.classList.add('is-loading');
    showResults(renderLoading());

    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ trackingNumber: lastTrackingNumber })
    })
    .then(function (res) { return res.json(); })
    .then(function (json) {
      btn.classList.remove('is-loading');
      if (json.success && json.data) {
        showResults(renderSuccess(json.data));
      } else {
        showResults(renderError());
      }
    })
    .catch(function () {
      btn.classList.remove('is-loading');
      showResults(renderError());
    });
  }

  /* ── Form submit ── */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    doTrack(input.value);
  });

  /* ── FAQ accordion ── */
  var faqItems = document.querySelectorAll('.avora-tracking__faq-item');
  faqItems.forEach(function (item) {
    var trigger = item.querySelector('.avora-tracking__faq-trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var answer = item.querySelector('.avora-tracking__faq-answer');
      var isOpen = item.classList.contains('is-open');

      if (isOpen) {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = '0';
      } else {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* ── URL param auto-search ── */
  var params = new URLSearchParams(window.location.search);
  var autoTrack = params.get('track');
  if (autoTrack) {
    input.value = autoTrack;
    // Small delay so page renders first
    setTimeout(function () {
      doTrack(autoTrack);
    }, 300);
  }
})();
